export default __webpack_public_path__ + "static/media/Merge4.1732ebd1.png";